import {
  addHooksToOneTrustButtons,
  configureSegmentOt,
  loadSegment,
} from '@frameio/segment-ot';

// Minimal integrations required for Enterprise customers who have data restrictions
const CORE_DESTINATIONS = {
  Appcues: true,
  Intercom: true,
};

/**
 * global window definitions use declarative merging to automatically combine
 * https://www.typescriptlang.org/docs/handbook/declaration-merging.html
 */

declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    adobePrivacy: {
      loadOneTrust: () => void;
      showPreferenceCenter: () => void;
    };
    // segment-ot adds an integrations key in window to list the integrations.
    integrations: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fedsConfig?: any;
  }
}

/**
 * Generic function to load Segment in the app. Takes an object containing an
 * integrations object. The integrations object tells Segment what integrations
 * should be loaded.
 * @param {string} segmentId - SegmentId
 * @param {boolean} isRestricted - Boolean describing whether or not to restrict which integrations are loaded
 * @param {object} options - An object passed to the second argument of `AnalyticsBrowser.load`. You can view
 *  the following for the shape of this object and what kinds of properties it accepts
 *  https://github.com/segmentio/analytics-next/blob/master/packages/browser/src/browser/settings.ts#L204.
 *
 * @example
 * const isRestricted = false;
 * loadSegmentOt(segmentId, isRestricted);
 */
export async function loadSegmentOt(
  segmentId: string,
  isRestricted: boolean,
  options = {}
) {
  configureSegmentOt({
    isEnterpriseDataRestrictionsEnabled: isRestricted,
    coreDestinations: CORE_DESTINATIONS,
    groupRestrictions: [],
    segmentWriteKey: segmentId,
    shouldIncludeIntegrations: false,
  });

  if (window && window.adobePrivacy) {
    await window.adobePrivacy.loadOneTrust();
  }

  await loadSegment(options);
  addHooksToOneTrustButtons();
}

export const openCookiePreferences = () => {
  if (window && window.adobePrivacy) window.adobePrivacy.showPreferenceCenter();
};
